import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getProduct() {
  const data = await axiosInstance({
    url: "/product",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createProduct(formData) {
  const data = await axiosInstance({
    url: "/product",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updateProduct(formData) {
  const data = await axiosInstance({
    url: `/product/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deleteProduct(formData) {
  const data = await axiosInstance({
    url: `/product/${formData}`,
    method: "DELETE",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useProduct() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.product],
    queryFn: getProduct,
  });
  return data;
}

export function useUpdateProduct() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateProduct(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.product]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddProduct() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createProduct(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.product]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
export function useDeleteProduct() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deleteProduct(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.product]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
